// extracted by mini-css-extract-plugin
module.exports = {"noTransform":"customMenuList_noTransform__2povf","alert-margin":"customMenuList_alert-margin__3Vi24"};